

























































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import { DataStore, DataItem } from '@/utils';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listMealType: I.CodeData[];
  listUserEventCode: I.CodeData[];
  listDoorEventCode: I.CodeData[];
  listSensorEventCode: I.CodeData[];
  listSystemEventCode: I.CodeData[];
  listUserStatus: I.CodeData[];
  listUserType: I.CodeData[];

  // listDoor: I.DoorData[];
  listDoor: I.CodeData[];

  // listACU: I.AcuDetail[];
  listACU: I.CodeData[];

  // listSensor: I.DeviceData[];
  listSensor: I.CodeData[];

  empEventList: I.PersonalEventList;
  companyEventList: I.CompanyEventList;
  cornerEventList: I.CornerEventList;
  dayEventList: I.DayEventList;
  mealEventList: I.MealEventList;
  errorEventList: I.ErrorEventList;

  searchType: number;

  constructor() {
    this.listACU = [];
    this.listSensor = [];
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listMealType = [];
    this.listDoor = [];
    this.listUserEventCode = [];
    this.listDoorEventCode = [];
    this.listSensorEventCode = [];
    this.listSystemEventCode = [];
    this.listUserStatus = [];
    this.listUserType = [];
    this.searchType = 0;

    this.empEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.companyEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.cornerEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.dayEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.mealEventList = {
      listEvent: [],
      searchCount: 0
    };
    this.errorEventList = {
      listEvent: [],
      searchCount: 0
    };
  }

  get cleared() {
    return (
      [
        this.listACU,
        this.listSensor,
        this.listCompanyCode,
        this.listDeptCodeA,
        this.listDeptCodeB,
        this.listDutyCodeA,
        this.listMealType,
        this.listDoor,
        this.listUserEventCode,
        this.listDoorEventCode,
        this.listSensorEventCode,
        this.listSystemEventCode,
        this.listUserStatus
      ]
        .map(x => x.length > 0)
        .filter(x => x === true).length === 0 &&
      this.searchType === 0 &&
      this.searchType === 0
    );
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

enum TabKind {
  AllStatus,
  AllType,
  AllNoUse,
  CompanyStatus,
  CompanyType
}

@Component
class ApiImpl extends Mixins(AxPage) {
  currentTab!: TabKind;
  API!: AxAPI;

  async searchAPI(packet: I.PacketUserStatusSearch) {
    console.log(packet);
    switch (this.currentTab) {
      case TabKind.AllStatus:
        return this.API.call.user.statusAllSearch(packet);
      case TabKind.AllType:
        return this.API.call.user.typeAllSearch(packet);
      case TabKind.AllNoUse:
        return this.API.call.user.notUseAllSearch(packet);
      case TabKind.CompanyStatus:
        return this.API.call.user.statusCompanySearch(packet);
      case TabKind.CompanyType:
        return this.API.call.user.typeCompanySearch(packet);
    }
  }

  async execSearch(packet: I.PacketUserStatusSearch) {
    this.setLoading(true);
    const result = await this.searchAPI(packet);
    this.setLoading(false);
    console.log(result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

interface NumHeader {
  num?: number;
  userStatusName?: string;
  total?: number;
  imCard?: number;
  saneCard?: number;
  saweCard?: number;
  imsiCard?: number;
  bangCard?: number;
  userTypeName?: string;
  useCard?: number;
  stopCard?: number;
}

@Component
class DataItemImpl extends Vue {
  currentTab!: TabKind;
  dataItems: DataItem<unknown, State>[] = [
    {
      name: '전체(상태)',
      store: new DataStore<I.UserStatusAllData & NumHeader>({
        headers: {
          num: { text: '순번', sortable: false },
          userTypeName: '이름',
          total: '총계',
          useCard: '사용',
          stopCard: '정지',
          leaveCard: '휴직',
          resignCard: '퇴사',
          moveCard: '전출'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '전체(유형)',
      store: new DataStore<I.CompanyData & NumHeader>({
        headers: {
          num: '순번',
          userStatusName: '이름',
          total: '총계',
          imCard: '임직원',
          saneCard: '사내협력',
          saweCard: '사외협력',
          imsiCard: '임시증',
          bangCard: '방문증'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '전체(미사용)',
      store: new DataStore<I.CornerData & NumHeader>({
        headers: {
          num: '순번',
          userTypeName: '이름',
          total: '총계',
          useCard: '사용',
          stopCard: '미사용'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '사용자 상태',
      store: new DataStore<I.UserStatusCompanyData & NumHeader>({
        headers: {
          num: '순번',
          companyName: '이름',
          total: '총계',
          useCard: '사용',
          stopCard: '정지',
          leaveCard: '휴직',
          resignCard: '퇴사',
          moveCard: '전출'
        }
      }),
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '사용자 유형',
      store: new DataStore<I.UserTypeCompanyData & NumHeader>({
        headers: {
          num: '순번',
          companyName: '이름',
          total: '총계',
          imCard: '임직원',
          saneCard: '사내협력',
          saweCard: '사외협력',
          imsiCard: '임시증',
          bangCard: '방문증'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentTab];
  }
}

@Component
class SelectDialogImpl extends Vue {
  dialogState!: DialogState;
  pageInfo!: I.UserSearchPageInfo;
  zoneCode!: number;
  dataItem!: DataItem<unknown, State>;

  openCodeSelectDialog(title: string, name: string) {
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    const selected = ((this.dataItem.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.dataItem.state as unknown) as { [name: string]: I.CodeData[] })[
        name
      ] = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openMealTypeSelectDialog() {
    const title = '식수 유형 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = this.pageInfo.listUserType;
    const selected = this.dataItem.state.listMealType;

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      this.dataItem.state.listMealType = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openReaderSelectDialog() {
    const title = '리더기 선택';
    const headers = [{ text: '이름', value: 'name', align: 'start' }];

    // 현재 선택된 구역 코드만 나오도록 함
    const items = this.pageInfo.listDoor.filter(x => x.zoneCode === this.zoneCode);
    const selected = this.dataItem.state.listDoor;

    const callback = async () => {
      const selected = this.dialogState.selected as I.DoorData[];
      this.dataItem.state.listDoor = selected
        .sort((a, b) => (a.code > b.code ? 1 : -1))
        .map(x => {
          const codeData: I.CodeData = {
            code: x.code.toString(),
            name: x.name
          };
          return codeData;
        });
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    this.dialogState.show = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    const idx = this.dialogState.selected.findIndex(x => x === item);
    if (idx > -1) {
      this.dialogState.selected.splice(idx, 1);
    } else {
      this.dialogState.selected.push(item);
    }
  }
}

@Component
class ExcelImpl extends Mixins(AxPage) {
  dataItem!: DataItem<unknown, State>;

  async onExportExcelConfirm(prefix: string) {
    if (this.dataItem.store.items.length === 0) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = (x as unknown) as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime(((x as unknown) as { [key: string]: string })[y]));
          } else {
            arr.push(((x as unknown) as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

@Component
export class DateImpl extends Vue {
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;

  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;
}

@Component
export class AdvSearchImpl extends Mixins(AxPage) {
  isOpenAdvSearch!: boolean;
  dataItem!: DataItem<unknown, State>;

  onToggleAdvSearch() {
    this.isOpenAdvSearch = !this.isOpenAdvSearch;
  }

  async confirmClearAdvSearch(text: string) {
    const result = await this.showConfirmModal('확인', text, ['네', '아니오']);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearAdvSearch() {
    const result = await this.showConfirmModal('확인', '고급 검색 필터를 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearSearch() {
    this.dataItem.search = '';
  }
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const MixinClasses = Mixins(
  Mixins(ApiImpl, DataItemImpl, SelectDialogImpl, ExcelImpl, DateImpl),
  Mixins(AdvSearchImpl, AxPage)
);

@Component
export default class MealIndex extends MixinClasses {
  currentTab: TabKind = TabKind.AllStatus;
  dialogState = new DialogState();
  isOpenAdvSearch = false;

  zoneCode = 0;

  pageInfo: I.UserSearchPageInfo = {} as I.UserSearchPageInfo;
  staffList: I.TempStaffHistoryList[] = [];

  async prepare() {
    const baseData = await this.getBaseData();
    console.log(baseData);
    if (baseData) {
      this.pageInfo = baseData;

      // TODO: 이벤트 검색 구역 선택 State 저장
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }

  async getBaseData() {
    const result = await this.API.call.user.userSearchPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  dates = [];

  // TODO: 리더기, 식수 유형 구현해야 함
  async onSearchUserEvent() {
    const packet: I.PacketUserStatusSearch = {
      listCompanyCode: this.dataItem.state.listCompanyCode,
      listDeptCodeA: this.dataItem.state.listDeptCodeA,
      listDeptCodeB: this.dataItem.state.listDeptCodeB,
      listDutyCode: this.dataItem.state.listDutyCodeA,
      listUserStatus: this.dataItem.state.listUserStatus,
      listUserType: this.dataItem.state.listUserType,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      searchType: this.currentTab,
      isSearchIssueDate: true
    };

    const result = await this.execSearch(packet);

    if (result) {
      this.dataItem.store.setItems(result);
    }
  }
}
